import templateBase from './templates/dynamic-filters-base.view.html';
import templateAD from './templates/dynamic-filters.view-adaptative.html';
function DynamicFiltersDirective(SessionService) {
    let response = SessionService.get('components');
    let htmlTemplate = templateBase;
    if (__env.adaptative){
      htmlTemplate = templateAD;
    }


    return {
      restrict: 'E',
      template: htmlTemplate
    };
}

DynamicFiltersDirective.$inject = ['SessionService'];

export default DynamicFiltersDirective;





// WEBPACK FOOTER //
// ./www/components/catalog/products-list/dynamic-filters/dynamic-filters.directive.js